module.exports = __webpack_public_path__ + "static/media/sis.65b0e9c8.svg";